
import { GlobalController } from 'src/shared/global/GlobalController'
import ConsumerUnit from './ConsumerUnit'
const ifAuthenticated = (to, from, next) => {
  GlobalController.getAsyncInstance().then(data => {
    if (data && data.authResp && data.authResp.token) {
      next()
    } else {
      next('/')
    }
  })
}
export const routes = [
  {
    path: ':link',
    name: 'consumerUnit',
    component: ConsumerUnit,
    beforeEnter: ifAuthenticated,
    props: true
  }
]
